import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getPanCakeIconDetails } from "../../services/userServices";
import PiiReportOracleIdDisplay from "../../components/PiiReportOracleIdDisplay/PiiReportOracleIdDisplay";
import { useAuth } from "context/AuthContext";

const PIIReportByOracleId = () => {
  const { oracleId } = useParams();
  const { hasPermission } = useAuth();
  const [reportDisplay, setReportDisplay] = useState(false);

  useEffect(() => {
    // let panCakeIconDetails = await getPanCakeIconDetails();
    // if (panCakeIconDetails.status) {
    //   let data = panCakeIconDetails.data.data[0];
    //   if (data.IsEligible || data.IsAdminEligible) {
    //     setReportDisplay(true);
    //   }
    // }
    if (hasPermission("PII_Group_FULL")) {
      setReportDisplay(true);
    }
  }, [hasPermission]);

  return (
    <div>
      <>
        {reportDisplay ? (
          <>
            <PiiReportOracleIdDisplay
              oracleId={oracleId}
            ></PiiReportOracleIdDisplay>
          </>
        ) : (
          <>Not eligible to access this page.</>
        )}
      </>
    </div>
  );
};

export default PIIReportByOracleId;
